export default __webpack_public_path__ + "static/media/chemical.cc6fde6a.jpg";